import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import AccordionItem from '../../../../components/Accordion/AccordionItem';
import {
  selectCurrentSignatureTemplateName,
  selectDefaultSignature
} from '../../../../redux/modules/emails';
import EmailSignature from '../EmailComponents/EmailSignature';

function SignatureDropdown() {
  const defaultSignature = useSelector(selectDefaultSignature);
  const currentSignatureTemplateName = useSelector(selectCurrentSignatureTemplateName);
  const [isOpen, toggleIsOpen] = useState(false);

  const { templateName = '', templateInfo: { html } } = defaultSignature;

  return (
    <AccordionItem
      isOpen={isOpen}
      title={`SIGNATURE: (${currentSignatureTemplateName || templateName})`}
      toggle={toggleIsOpen}
    >
      <EmailSignature
        backgroundColor="greyScale.100"
        signatureContainerId="signature-editor"
      />
    </AccordionItem>
  );
}

export default SignatureDropdown;
